module.exports = __webpack_public_path__ + "img/persona dreamdeal tech (3)-25.eed98235.jpg";